import { ClientConfig } from './client-config.interface';

/** @docsReference: https://developers.hubspot.com/docs/api/conversation/chat-widget-sdk */
class WidgetConfig {
	private clientConfig: ClientConfig;

	constructor() {
		this.clientConfig = { loadImmediately: false, widgetOpen: false };
	}

	private setClientConfig(): void {
		window['hsConversationsSettings'] = this.clientConfig;

		/* Update HubSpot config */
		window['HubSpotConversations']?.widget?.refresh();
	}

	public show(): void {
		this.clientConfig.widgetOpen = true;
		this.setClientConfig();
	}

	public hide(): void {
		this.clientConfig.widgetOpen = false;
		this.setClientConfig();
	}
}

export const HubspotUtil = { widget: new WidgetConfig() };
